import {atom} from "jotai";
import {Icon} from "../../../components/table";
import {dateFormat, decimalFormat} from "../../../common/StringUtils";
import {Check} from "../../../assets/GlobalStyles";
import {ImageView} from "../ProductManage";
import React from "react";

/**
 * 상품 수집 관리 리스트 Atom
 */
export const productListDataAtom = atom({})

export const searchProductType = [
  {id: "1", value: "DEFAULT", label: "전체"},
  {id: "2", value: "PRODUCT_CODE", label: "상품코드"},
  {id: "3", value: "PRODUCT_NAME", label: "상품명"}
]

/**
 * 상품 수집 관리 리스트 컬럼 설정
 */
export const productListColumn = [
  {
    name: 'username',
    header: () => {
      return (
        <div><p>광고주</p><p>아이디</p></div>
      )
    },
    label: '광고주 아이디',
    textAlign: 'center',
    minWidth: 80,
    showColumnMenuTool: false
  },
  {
    name: 'productCode',
    header: '상품 코드',
    label: '상품 코드',
    textAlign: 'center',
    width: 80,
    sortable: false, //정렬
    resizeable: false,
    showColumnMenuTool: false,
    render: ({value, cellProps}) => {
      return <Icon icon={'copyCode'} value={value} cellProps={cellProps}/>
    }
  },
  {
    name: 'createdAt',
    header: '등록 일시',
    label: '등록 일시',
    textAlign: 'center',
    width: 90,
    resizeable: false,
    showColumnMenuTool: false,
    render: ({value}) => {
      return <p>{dateFormat(value, 'YYYY.MM.DD HH:mm:ss')}</p>
    }
  },
  {
    name: 'productStatusType',
    header: () => {
      return (
        <div><p>중지/품절</p><p>여부</p></div>
      )
    },
    label: '중지/품절 여부',
    textAlign: 'center',
    width: 100,
    resizeable: false,
    showColumnMenuTool: false,
    render: ({value}) => {
      return <Check/>
    }
  },
  {
    name: 'productImages',
    header: () => {
      return (
          <div><p>상품</p><p>이미지1</p></div>
      )
    },
    label: '상품 이미지1',
    textAlign: 'center',
    minWidth: 100,
    maxWidth: 100,
    showColumnMenuTool: false,
    sortable: false,
    render: (props) => {
      return (
        <>
          {props.cellProps.data.productImages.length !== 0 ?
            <img src={props.cellProps.data.productImages[0].imageUrl} style={{height: 30}} alt={'이미지'}/>
            :
            <span>-</span>
          }
        </>
      )
    }
  },
  {
    name: 'productImages2',
    header: () => {
      return (
          <div><p>상품</p><p>이미지2</p></div>
      )
    },
    label: '상품 이미지2',
    textAlign: 'center',
    minWidth: 100,
    maxWidth: 100,
    showColumnMenuTool: false,
    sortable: false,
    render: (props) => {
      return (
        <>
          {props.cellProps.data.productImages.length > 1 ?
            <ImageView url={props.cellProps.data.productImages[1]}/>
            :
            <span>-</span>
          }
        </>
      )
    }
  },
  {
    name: 'productImages3',
    header: () => {
      return (
          <div><p>상품</p><p>이미지3</p></div>
      )
    },
    label: '상품 이미지3',
    textAlign: 'center',
    minWidth: 100,
    maxWidth: 100,
    showColumnMenuTool: false,
    sortable: false,
    render: (props) => {
      return (
        <>
          {props.cellProps.data.productImages.length > 2 ?
            <ImageView url={props.cellProps.data.productImages[2]}/>
            :
            <span>-</span>
          }
        </>
      )
    }
  },
  {
    name: 'productCategorys',
    header: () => {
      return (
        <div><p>표준 카테고리</p><p>(seq)</p></div>
      )
    },
    label: '표준 카테고리 (seq)',
    textAlign: 'center',
    minWidth: 100,
    maxWidth: 100,
    showColumnMenuTool: false,
    render: (props) => {
      return (
        <>
          {props.cellProps.data.productCategorys.length !== 0 ?
            <span>{props.cellProps.data.productCategorys[0].name}</span>
            :
            <span>-</span>
          }
        </>
      )
    }
  },
  {
    name: 'productCategorys1',
    header: () => {
      return (
        <div><p>상품</p><p>카테고리1</p></div>
      )
    },
    label: '상품 카테고리1',
    textAlign: 'center',
    minWidth: 100,
    maxWidth: 100,
    showColumnMenuTool: false,
    render: (props) => {
      return (
        <>
          {props.cellProps.data.productCategorys.length > 1 ?
            <span>{props.cellProps.data.productCategorys[1].name}</span>
            :
            <span>-</span>
          }
        </>
      )
    }
  },
  {
    name: 'productCategorys2',
    header: () => {
      return (
        <div><p>상품</p><p>카테고리2</p></div>
      )
    },
    label: '상품 카테고리2',
    textAlign: 'center',
    minWidth: 100,
    maxWidth: 100,
    showColumnMenuTool: false,
    render: (props) => {
      return (
        <>
          {props.cellProps.data.productCategorys.length > 2 ?
            <span>{props.cellProps.data.productCategorys[2].name}</span>
            :
            <span>-</span>
          }
        </>
      )
    }
  },
  {
    name: 'productName',
    header: '상품명',
    label: '상품명',
    textAlign: 'center',
    minWidth: 200,
    showColumnMenuTool: false,
    render: ({value}) => <p className={'ellipsis'}>{value}</p>
  },
  {
    name: 'price',
    header: '원가',
    label: '원가',
    textAlign: 'center',
    minWidth: 100,
    maxWidth: 100,
    showColumnMenuTool: false,
    render: ({value}) => <p className={'won'}>{decimalFormat(value)}</p>
  },
  {
    name: 'discountRate',
    header: '할인가',
    label: '할인가',
    textAlign: 'center',
    minWidth: 100,
    maxWidth: 100,
    showColumnMenuTool: false,
    render: (props) => {
      const price = parseFloat(props.cellProps.data.price)
      const discount = parseFloat(props.cellProps.data.discountRate)
      const value = price - (price / discount)
      return (
        <p className={'won'}>{decimalFormat(value)}</p>
      )
    }
  },
  {
    name: 'productUrl',
    header: '사이트',
    label: '사이트',
    textAlign: 'center',
    minWidth: 100,
    maxWidth: 100,
    sortable: false,
    showColumnMenuTool: false,
    render: ({value, cellProps}) => {
      return (
        <div style={{display: 'flex', justifyContent:'center',alignItems: 'center'}}>
          <p>이동</p> <Icon icon={'url'} value={value} cellProps={cellProps}/>
        </div>
      )
    }
  },
  {
    name: 'ratingPoint',
    header: '평점',
    label: '평점',
    textAlign: 'center',
    minWidth: 100,
    maxWidth: 100,
    showColumnMenuTool: false
  },
  {
    name: 'reviewCount',
    header: '리뷰수',
    label: '리뷰수',
    textAlign: 'center',
    minWidth: 100,
    maxWidth: 100,
    showColumnMenuTool: false
  },
  {
    name: 'keyword',
    header: '키워드',
    label: '키워드',
    textAlign: 'center',
    minWidth: 100,
    maxWidth: 100,
    showColumnMenuTool: false
  }
]
